<template>
  <div v-if="show" class="mobile-breadcumbs">
    <p class="breadcrumbs-txt">{{modifiedBreadcrumbs}}</p>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
    computed:{
        ...mapGetters({
          breadcrumbs:'breadcrumbs/breadcrumbs'
        }),
        show(){
            return this.breadcrumbs.length > 0 &&
                (this.$route.name === 'ProductsIndex' || this.$route.name === 'SearchIndex')
        } ,
        modifiedBreadcrumbs(){
          let b = this.breadcrumbs.slice().pop().name
          if(b.split(' ').find(s=> s === 'results')){
            let s = ''
            b.split(' ').slice(0,2).forEach(k=>{
              s += k +' '
            })
            return s
          }
          return b
        }
    }
}
</script>

<style scoped>
@media only screen and (max-width: 768px){
  .mobile-breadcumbs{
    font-size: 15px;
    height: 21px;
    font-weight: 500;
    color: black;
    display: flex;
    align-items: center;
    margin-right: auto;
    width: 30%;
  }
  .breadcrumbs-txt{
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>


// WEBPACK FOOTER //
// resources/js/components/layouts/MobileBreadcrumbsResults.vue